import { ENDPOINTS } from "@/constants/apiConstants";
import { apiSlice } from "../baseApi";

const transactionBaseEndpoint = ENDPOINTS.TRANSACTION;

//Transaction Api
export const customerApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["transactions"],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getTransactions: builder.query({
        query: ({ page = 1, per_page = 10, search = "" } = {}) => ({
          url: `${transactionBaseEndpoint}`,
          params: {
            page,
            per_page,
            ...(search && { search }),
          },
        }),
        transformResponse: (response) => {
          return response?.data || response;
        },
      }),
      getTransactionsMonthlyStats: builder.query({
        query: (payload) => `${transactionBaseEndpoint}/monthly-stat`,
        providesTags: () => [{ type: "transactions" }],
        // keepUnusedDataFor: 0, // Set to 0 seconds to always fetch fresh data
      }),
      getRevenue: builder.query({
        query: (payload) => `${transactionBaseEndpoint}/revenue`,
        transformResponse: (response) => response.data,
        providesTags: () => [{ type: "transactions" }],
        // keepUnusedDataFor: 0, // Set to 0 seconds to always fetch fresh data
      }),
      //   addDailyOrders: builder.mutation({
      //     query: (requestData) => ({
      //       url: "/Company/requestDemo",
      //       method: "POST",
      //       body: requestData,
      //     }),
      //     invalidatesTags: () => [{ type: "dailyOrders" }],
      //   }),
    }),
  });

// Export hooks for usage in components

export const { useGetTransactionsQuery, useGetRevenueQuery, useGetTransactionsMonthlyStatsQuery } = customerApi;
